import React from 'react'

const UserInfo = ({user}) => {

  return (
    <div className='flex flex-col items-left'>
        <p>Email: {user?.email}</p>
        <p>Phone Number: {user?.phoneNumber}</p>
        <p>Birthday: {user?.birthday}</p>
        <p>Address: {user?.address}</p>
    </div>
  )
}

export default UserInfo